export default __webpack_public_path__ + "static/media/G0120.34I-29376_-17331_0-RS.1709298180000.1285b9d6.jpg";